import { ErrorLabel } from '@screens/review-section3/pincode-authorisation/pin-code-form-styles';
import { getPinCodeFormTranslations } from '@screens/review-section3/pincode-authorisation/translations';
import { IAuthenticationStore } from '@stores/authentication/authentication-store';
import { observer } from 'mobx-react';
import * as React from 'react';

interface IPinCodeAuthenticationFeedbackLabelProps {
    authenticationStore: IAuthenticationStore;
    className?: string;
}

export const PinCodeAuthenticationFeedbackLabel: React.FunctionComponent<
    IPinCodeAuthenticationFeedbackLabelProps
> = observer(props => {
    const {
        authenticationStore,
        className
    } = props;

    const translations = getPinCodeFormTranslations();

    if (!authenticationStore.didFailAuthentication) {
        return null;
    }

    return (
        <ErrorLabel className={className}>{translations.invalidPinCodeLabel}</ErrorLabel>
    );
});



// WEBPACK FOOTER //
// ./src/screens/review-section3/pincode-authorisation/feedback-label.tsx